import React from 'react';
import IndividualGlyph from './IndividualGlyph';

export enum GlyphType {
  Triangle = 'triangle',
  Square = 'square',
  Diamond = 'diamond',
  Dot = 'dot',
  Circle = 'circle',
  Noop = 'noop',
};

type GlyphSequenceProps = {
  glyphString: string;
  lineNumber: number;
};

const getMarkupForGlyphs = (glyphString: string, lineNumber: number) => {
  const glyphSections = glyphString.split(/(\([^)]+\))/)
    .map(s => s.trim()).filter(Boolean);
  let glyphIndex = 0;

  return glyphSections.flatMap((section, i1) => {
    const isSumBlock = section.startsWith('(');
    const glyphsForSection = section
      .slice(isSumBlock ? 1 : 0, isSumBlock ? -1 : undefined) // slice off the parens if needed
      .split(' ')
      .map((glyph, i2) => 
        <IndividualGlyph
          key={`${i1}-${i2}`}
          glyphType={glyph as GlyphType}
          index={glyphIndex++}
          lineNumber={lineNumber}
        />
      );

    return isSumBlock
      ? <div key={i1} className="sumblock">{glyphsForSection}</div>
      : glyphsForSection;
  });
};

const GlyphSequence = ({ glyphString, lineNumber }: GlyphSequenceProps) => {
  const glyphMarkup = getMarkupForGlyphs(glyphString, lineNumber);

  // Remove parens and then just count the operators/glyphs/whatever.
  // This is so we can scale long lines down slightly to fit better on mobile devices.
  const glyphCount = glyphString.replace(/[\(\)]/g, '')
    .trim()
    .split(/\s+/).length;

  const classes = ['glyphSequence'];
  if (glyphCount === 8) classes.push('eightOperators');
  if (glyphCount === 9) classes.push('nineOperators');

  return (
    <div className={classes.join(' ')}>
      {glyphMarkup}
    </div>
  );
};

export default GlyphSequence;